<template>
  <div class="article">
    <Form @submitSuccess="search" ref="form"/>
    <FilterForm :fields="searchFields" @submit="search" />
    <div class="groupButton">
      <AppButton customType="default" @click="addMenu">添加文章</AppButton>
    </div>
    <BasicTable
      :tableData="tableData"
      :pageSize="pageQuery.per_page"
      :columns="columns" 
      :currentPage="pageQuery.current_page"
      :total="pageQuery.total"
      @pageChange="pageChange"
    >
      <template v-slot:title="{ item }">
        <div @click="gotoDetail(item)" class="toDetail">{{ item.title }}</div>
      </template>
      <template v-slot:is_enable="{ item }">
        <CheckBox v-model="item.is_enable" @change="enableArticle(item)" ></CheckBox>
      </template>
      <template v-slot:is_home_recommended="{ item }">
        <CheckBox v-model="item.is_home_recommended" @change="recommendedArticle(item)" ></CheckBox>
      </template>
      <template v-slot:add_time="{ item }">
        {{ item.add_time*1000 | dateFormat('YYYY-MM-DD') }}
      </template>
      <template v-slot:operate="{ item }">
        <AppButton type="primary" plain size="small" @click="editMenu(item)"><i class="fa fa-edit fa-lg icon" ></i>编辑</AppButton>
        <AppButton type="primary" plain size="small" @click="deleteMenu(item)"><i class="fa fa-trash-o fa-lg icon"></i>删除</AppButton>
      </template>
    </BasicTable>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui';
import { ArticleService } from '../../service/article.service'
import Form from './formArticleList';
const columns = [
  { name: '名称', key: 'title', type: 'custom' },
  { name: '分类', key: 'article_category_name'},
  { name: '是否启用', key: 'is_enable', type: 'custom'},
  { name: '推荐', key: 'is_home_recommended',type: 'custom'},
  { name: '添加时间',key: 'add_time',type: 'custom'},
  { name: '热度',key: 'access_count'},
  { name: '操作', key: 'operate', type: 'custom'}
];
var classification = []
  export default {
    name: 'articleList',
    components: { Form },
    data() {
      return {
        tableData: [],
        pageQuery: {
          page: 1,
          total: 0,
          per_page:10
        },
        searchVal: {},
        columns,
        catList: [],
        classification,
        searchFields: [{
                key: 'keywords',
                id: '1',
                type: 'input',
                name: '名称',
            },{
                key: 'is_enable',
                id: '2',
                type: 'select',
                name: '启用',
                options: [{
                    value: '1',
                    label: '是'
                },{
                    value: '0',
                    label: '否'
                }]
            },{
              key: 'article_category_id',
              id: '3',
              type: 'select',
              name: '分类',
              options: classification
            },{
              key: 'is_home_recommended',
              id: '4',
              type: 'select',
              name: '是否推荐',
              options: [{
                value: '1',
                label: '是'
              },{
                value: '2',
                label: '否'
              }]
            },{
              key: 'access_count',
              id: '5',
              type: 'number',
              name: '热度'
            },{ 
                class: 'time',
                key: 'time_start',
                id: '6',
                type: 'date',
                name: '时间',
                placeholder: '起始时间'
            },{
                class: '',
                name: '~',
                key: 'time_end',
                id: '7',
                type: 'date',
                placeholder: '结束时间'
            }]
        }
    },
    created() {
      this.getList();
    },
    methods: {
      async getList() {
        const data = await ArticleService.getList();
        this.tableData = data.list.data;
        this.catList = data.cat_list;
        this.pageQuery.per_page = data.list.per_page
        this.pageQuery.total = data.list.total
        data.cat_list.map(val => {
          let obj = {}
          obj.value = val.id
          obj.label = val.name
          this.classification.push(obj)
        })
        let obj = {}
        this.classification = this.classification.reduce(function(item, next) {
           obj[next.value] ? '' : obj[next.value] = true && item.push(next);
           return item;
        }, []);
        this.searchFields.map(item=>{
          if(item.key == "article_category_id") {
            item.options = this.classification
          }
        })
        localStorage.setItem("classification",JSON.stringify(this.classification))
      },
      addMenu() {
        this.$refs.form.open('add',{},this.classification);
      },
      async search(val) {
          if(val) this.searchVal = val
          const data = await ArticleService.getList(this.searchVal,this.pageQuery);
          this.pageQuery.per_page = data.list.per_page
          this.pageQuery.total = data.list.total
          this.tableData = data.list.data;
      },
      async pageChange(index) {
        this.pageQuery.page = index
        const data = await ArticleService.getList(this.searchVal,this.pageQuery);
        this.tableData = data.list.data;
      },
      editMenu(data) {
        this.$refs.form.open('edit', data,this.classification);
      },
      deleteMenu(data) {
        MessageBox.confirm('确定要删除这条文章吗？', '删除文章').then(async () => {
          await ArticleService.delArticle(data.id)
          this.getList();
        })
      },
      filter() {
        this.getList();
      },
      enableArticle(item) {
          ArticleService.swichArticleStatus(item.id, item.is_enable ? 1 : 0);
      },
      recommendedArticle(item) {
          ArticleService.swichArticleRecommendStatus(item.id, item.is_home_recommended ? 1 : 0)
      },
      gotoDetail(item) {
        this.$router.push({path:'/articleListDetail',query: {id:item.id}})
      }
    }
  }
</script>

<style lang="scss" scoped>
.icon {
  font-size: 1vw;
}
</style>

<style lang="scss">
.article .el-date-editor.el-input,.article .el-date-editor.el-input__inner{
  width: 185px;
}
</style>